import { render, staticRenderFns } from "./shopodetail.vue?vue&type=template&id=160340f7&scoped=true"
import script from "./shopodetail.vue?vue&type=script&lang=js"
export * from "./shopodetail.vue?vue&type=script&lang=js"
import style0 from "./shopodetail.vue?vue&type=style&index=0&id=160340f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160340f7",
  null
  
)

export default component.exports